import * as React from 'react';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

const FatSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 45,              // wider than default (34)
  height: 26,             // taller than default (20)
  padding: 0,
  display: 'flex',
  '& .MuiSwitch-switchBase': {
    padding: 3,           // space around the thumb
    transitionDuration: '200ms',
    '&.Mui-checked': {
      transform: 'translateX(22px)', // move the bigger thumb
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#2B3A55',  // dark navy-ish ON color
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 20,            // larger thumb
    height: 20,
    boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
  },
  '& .MuiSwitch-track': {
    borderRadius: 34 / 2,
    backgroundColor: '#D9D9D9',      // light gray OFF
    opacity: 1,
  },
}));

export default function Toggle({label= "", onChange, checked = false}) {

  return (
    <FormControlLabel
      control={
        <FatSwitch
          checked={checked}
          onChange={onChange}
        />
      }
      label={label}
      sx={{
        margin: 0,
        '.MuiFormControlLabel-label': {
          fontSize: 15,
          fontWeight: 0,
          color: '#090101',
        },
        gap: 1.0, // spacing between switch and label
      }}
    />
  );
}
